@if (onInit$ | async) {
  <div class="container-single views-container">
    <div class="row">
      <div class="card">
        <div class="card-body">
          <app-dynamic-form-container [dynamicFormOptions]="dynamicFormContent">
          </app-dynamic-form-container>
        </div>
      </div>
    </div>
  </div>
}
